import { useEffect } from "react";
import CustomButton from "../../../components/CustomButton";
import CustomInput from "../../../components/CustomInput";
import SubHeadings from "../../../components/SubHeadings";
import { AddStudentForm, Student } from "../../../types/studentType";
import { useFormEdit } from "../../../util/hooks/useFormEdit";

interface otherInformationProps {
  form: ReturnType<typeof useFormEdit<Student>>;
}

export default function OtherDetails({ form }: otherInformationProps) {
  const { formData, setFormData, isEditing } = form;

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value, type } = event.target;

    let newValue: any = value;

    if (type === "radio") {
      if (value === "true") newValue = true;
      if (value === "false") newValue = false;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  return (
    <div className="px-4 md:px-9 flex flex-col md:flex-row gap-9">
      <div className="flex flex-col gap-7 w-full py-7">
        <SubHeadings text="Other Details" />
        <form className="grid gap-7">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
            <CustomInput
              name="fatherFullName"
              label="Father name"
              readOnly={!isEditing}
              type="text"
              placeholder="Enter Father name"
              value={formData.fatherFullName ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />

            <CustomInput
              name="fatherPhoneNumber"
              label="Father phone number"
              type="tel"
              readOnly={!isEditing}
              placeholder="Enter Father phone number"
              value={formData.fatherPhoneNumber ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />

            <CustomInput
              name="fatherEmail"
              label="Father email"
              type="email"
              readOnly={!isEditing}
              placeholder="Enter Father email"
              value={formData.fatherEmail ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />

            <CustomInput
              name="motherFullName"
              label="Mother name"
              readOnly={!isEditing}
              type="text"
              placeholder="Enter Mother name"
              value={formData.motherFullName ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />

            <CustomInput
              name="motherPhoneNumber"
              label="Mother phone number"
              type="tel"
              readOnly={!isEditing}
              placeholder="Enter Mother phone number"
              value={formData.motherPhoneNumber ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />

            <CustomInput
              name="motherEmail"
              label="Mother email"
              type="email"
              readOnly={!isEditing}
              placeholder="Enter Mother email"
              value={formData.motherEmail ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />
          </div>

          <div className="grid gap-4 md:items-center w-full">
            <CustomInput
              name="residentialAddress"
              label="Address"
              type="text"
              readOnly={!isEditing}
              placeholder="Enter Address"
              value={formData.residentialAddress ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
            <CustomInput
              name="emergencyContactName"
              label="Emergency contact name"
              type="text"
              readOnly={!isEditing}
              placeholder="Enter Emergency contact name"
              value={formData.emergencyContactName || ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />

            <CustomInput
              name="emergencyContactNumber"
              label="Emergency contact number"
              type="tel"
              readOnly={!isEditing}
              placeholder="Enter Emergency contact number"
              value={formData.emergencyContactNumber ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />
          </div>

          {/* <div className="flex justify-end items-end relative group">
            <CustomButton
              color="bg-primary-500"
              text="Submit"
              type="submit"
              disabled={!hasUnsavedChanges || !isEditing}
            />

            {!hasUnsavedChanges && (
              <span className="absolute bottom-full mb-2 bg-neutral-300 text-white text-xs font-medium px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                {isEditing
                  ? "No changes yet — fill out or edit the form to get started"
                  : "Enable edit mode to make changes"}
              </span>
            )}
          </div> */}
        </form>
      </div>
    </div>
  );
}
